"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarContentItem = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
function NavBarContentItem({ sx, children, ...rest }) {
    const theme = (0, material_1.useTheme)();
    const defaultSX = {
        paddingX: '1rem',
        paddingY: '0.375rem',
        height: '2.5rem',
        fontFamily: 'Effra',
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.5rem',
        letterSpacing: '0.025rem',
        color: theme.palette.primary.contrastText,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 'auto',
    };
    const mergedSX = { ...defaultSX, ...sx };
    return (react_1.default.createElement(material_1.Button, { sx: mergedSX, ...rest },
        react_1.default.createElement("div", { className: "flex flex-row gap-[0.5rem]" }, children)));
}
exports.NavBarContentItem = NavBarContentItem;
